import { FaCalendarDay, FaGauge, FaReadme, FaPenToSquare, FaUsers, FaGear, FaClipboardUser,FaHandsHoldingCircle } from "react-icons/fa6";

export default {
    header: {
        self: {},
        items: [],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                iconComponent: <FaGauge size={18} />,
                page: "dashboard",
                bullet: "dot",
            },
            {
                title: "Members",
                root: true,
                iconComponent: <FaUsers size={18} />,
                page: "member",
                bullet: "dot",
            },
            {
                title: "Posts",
                root: true,
                iconComponent: <FaPenToSquare size={18} />,
                page: "post",
                bullet: "dot",
            },
            {
                title: "Events",
                root: true,
                iconComponent: <FaCalendarDay size={18} />,
                page: "event",
                bullet: "dot",
            },
            {
                title: "Contents",
                root: true,
                iconComponent: <FaReadme size={18} />,
                page: "content",
                bullet: "dot",
            },
            {
                title: "Benefits",
                root: true,
                iconComponent: <FaHandsHoldingCircle size={18} />,
                page: "benefit",
                bullet: "dot",
            },
            {
                title: "Settings",
                root: true,
                iconComponent: <FaGear size={18} />,
                submenu: [
                    {
                        title: "Badges",
                        page: "badge",
                        bullet: "text",
                    },
                    {
                        title: "Galleria Tags",
                        page: "galleria-tag",
                        bullet: "text",
                    },
                ],
            },
            {
                title: "Access",
                root: true,
                iconComponent: <FaClipboardUser size={18} />,
                submenu: [
                    {
                        title: "Administrators",
                        page: "admin-user",
                        bullet: "text",
                    },
                    {
                        title: "Access Groups",
                        page: "admin-group",
                        bullet: "text",
                    },
                ],
            },
        ],
    },
};
